import Component from '../core/Component'
import debounce from 'lodash/debounce'
import { toggleClass } from '../utils/dom'

const STATES = {
    COLLAPSED: 'is-collapsed',
    HIDDEN: 'is-hidden'
}

const defaults = {
    openText: '',
    closedText: ''
}

export default class ExpandableText extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            toggle: null,
            textContainer: null
        }

        this.handleResize = debounce(this.handleResize, 200)
    }

    prepare() {
        if (!this.ref.toggle || !this.ref.textContainer) {
            return
        }
        this.ref.toggle.addEventListener('click', this.handleClick)
        window.addEventListener('resize', this.handleResize)
        this.resize()
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        const isShort = this.ref.textContainer.scrollHeight <= this.ref.textContainer.offsetHeight + 10

        toggleClass(this.ref.toggle, STATES.HIDDEN, isShort)
        if (isShort) {
            this.expand()
        }
    }

    toggle() {
        if (this.is(STATES.COLLAPSED)) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    expand() {
        this.element.classList.remove(STATES.COLLAPSED)
        this.ref.toggle.textContent = this.options.closedText
    }

    collapse() {
        this.element.classList.add(STATES.COLLAPSED)
        this.ref.toggle.textContent = this.options.openText
    }

}
